import styled from 'styled-components';

import theme from '../../assets/theme';

export const Container = styled.div`
	padding-bottom: 10px;
`;

export const InputStyled = styled.input`
	border: 1px solid ${theme.colors.dark};
	height: 4vh;
	padding-left: 10px;
`;
